const USUARIOS_CON_PERMISO = ["1", "7", "34", "591", "740", "743", "815", "831", "844", "847"]

const usuarioTienePermisoSuc = (id) => {
  return USUARIOS_CON_PERMISO.includes(String(id))
}

const permisos = ["Peticiones", "nuevo"]

export { USUARIOS_CON_PERMISO, usuarioTienePermisoSuc, permisos }
